<script>
export default {
    data: function(){
        return {
            tab_opened: 0
        }
    }
}
</script>